// src/components/NavigationGuard.js
import { useEffect } from "react";
import { customHistory } from "../history";

const NavigationGuard = () => {
  useEffect(() => {
    const unblock = customHistory.block((tx) => {
      const shouldNavigate = window.confirm("Are you sure you want to leave this page?");
      if (shouldNavigate) {
        unblock(); // allow future navigations without prompt
        tx.retry(); // proceed with navigation
      }
      // else: navigation stays blocked
    });

    const handleBeforeUnload = (e) => {
      e.preventDefault();
      e.returnValue = "";
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      unblock();
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  return null;
};

export default NavigationGuard;
